import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useState, useEffect, useRef } from "react";
import { useTheme } from "@emotion/react";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import ModalCharge from "../../modal/modalCharge";
import ModalProductosTejido from "../../modal/producto/modalProductoTejido";
import { postStockTejidos } from "../../services/stockTejido.services";
import ModalMaquinasTejido from "../../modal/maquinas/maquinasTejido";
import { toast } from "react-toastify";
import LoadingSpinner from "../../loadingSpinner";
import MenuItem from "@mui/material/MenuItem";
import secureStorage from "../../utils/secureStorage";

const StockTejido = () => {
  const [isModalChargeOpen, setIsModalChargeOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalMaquinaOpen, setIsModalMaquinaOpen] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  const [maquinaSeleccionada, setMaquinaSeleccionada] = useState(null);
  const [isModalTejidoOpen, setIsModalTejidoOpen] = useState(false);
  const [registrationError, setRegistrationError] = useState(false);
  const [error, setError] = useState("");
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [maquina2Seleccionada, setMaquina2Seleccionada] = useState(null);
  const [isModalMaquina2Open, setIsModalMaquina2Open] = useState(false);

  const theme = useTheme();

  const setFieldValueRef = useRef(null); // ⬅️ Referencia para setFieldValue

  const handleSelectProducto = (producto) => {
    if (setFieldValueRef.current) {
      setFieldValueRef.current("id_producto", producto.id);
    }
    setIsModalTejidoOpen(false);
  };

  const imprimirEtiqueta = async (item) => {
    try {
      const fecha = new Date(item.create_at || new Date()).toLocaleDateString(
        "es-ES",
      );
      const codigo = item.codigo || "TEJIDO";

      let zpl = ""; // Aquí seleccionamos el ZPL según el cliente

      if (item.id_cliente === 1) {
        // Etiqueta para Evoluaço
        zpl = `^XA

^FO10,5^GFA,9211,9211,61,,:V06,U01F,U03FC,U0IF,T03IFC,T0JFE,S01KF8,S07KFE,R01MF,R03MFC,R0OF,Q03OFC,Q0PFE,P01QF8,P07QFE,O01SF8,O07SFC,O0UF,N03UFC,N0VFE,M01WF8,M07WFE,L01YF8,L07YFC,L0gGF,K03gGFC,K0gIF,J01gIF8,J07QF0QFE,I01QFC03QF8,I07QF001QFE,I0QFEI07QF,003QF8I01QFC,00QFEK07QF,01QFCK03QF8,07QFM0QFE,1QFCM03QF8gY07FE,1QFCM03QF8gY07FF,1RFM0RF8gY07FF,1RF8K03RF8gY07FF,1RFEK07RF8gY07FF,1SF8I01SF8gY07FF,1SFCI03SF8gY07FF,1TFI0TF8gY07FF,1TFC03TF8gY07FF,1UF0UF8gY07FF,1gQF8gY07FF,::::1gQF8N03FFg0FFCK07FFV03FFCN0FFEN07FE,1KFC7WFE3KF8M03IFEI07FFCJ07FFCI07IF8J07FF00FFEI01FFCI03JF8L07IFCL03IFC,1KFC1WF83KF8M0KF8007FFEJ07FFC003KFJ07FF00FFEI01FFEI0KFEK01KFK01KF8,1KFC0WF03KF8L03KFE007FFEJ0IFC007KF8I07FF00IFI01FFE003LFK07KFCJ03KFC,1KFC03UFC03KF8L0MF003FFEJ0IF801LFEI07FF00IFI01FFE007LFCJ0LFEJ0MF,1KFC00UF003KF8K01MF803IFI01IF803MFI07FF00IFI01FFE00MFEI03MF8001MF8,1KFC007SFC003KF8K03MFC03IFI01IF807MF8007FF00IFI01FFE01NFI07MF8003MFC,1KFC001SF8003KF8K07MFE01IFI01IF00NFC007FF00IFI01FFE03NFI0NFC007MFE,1KFCI07QFEI03KF8K0OF01IF8003IF01NFE007FF00IFI01FFE01NF800NFE00OF,1KFCI01QF8I03KF8K0OF00IF8003IF01OF007FF00IFI01FFE01NF801NFE01OF,1KFCJ0PFEJ03KF8J01JF9JF80IF8003FFE03JFBJF007FF00IFI01FFE00FFE07IFC03OF01OF8,1KFCJ03OFCJ03KF8J03IFC01IF80IFC007FFE03IFC07IF807FF00IFI01FFE007F801IFC03IFC07IF83IFC03IFC,1KFCK0OFK03KF8J03IF800IFC07FFC007FFE07IF001IF807FF00IFI01FFE007EI07FFC07IF001IF03IF801IFC,1KFCK07MFCK03KF8J03IFI07FFC07FFC007FFC07FFEI0IFC07FF00IFI01FFE0038I07FFC07FFEI0FFE07IFI0IFC,1KFCK01MF8K03KF8J07FFEI03FFE07FFE007FFC0IFCI0IFC07FF00IFI01FFEM03FFC07FFCI07FC07FFEI07FFE,1KFCL07KFEL03KF8J07FFEI03FFE03FFE00IFC0IF8I07FFC07FF00IFI01FFEM03FFC0IFCI03F007FFCI03FFE,1KFCL01KF8L03KF8J07FFCI03FFE03FFE00IF80IFJ03FFE07FF00IFI01FFEM03FFC0IF8I01C00IF8I01FFE,1KFCM0JFEM03KF8J07FFCI01IF03IF00IF81IFJ03FFE07FF00IFI01FFEM07FFC0IFN0IF8I01IF,1KFCM03IF8M03KF8J0QF01IF01IF01IFJ01FFE07FF00IFI01FFEJ0LFC0IFN0IF8J0IF,1KFCN0IFN03KF8J0QF01IF01IF01FFEJ01FFE07FF00IFI01FFEI0MFC1IFN0IFK0IF,1KFCN07FCN03KF8J0QF00IF81IF01FFEJ01FFE07FF00IFI01FFE003MFC1IFN0IFK0IF,1KFCN01FO03KF8J0QF00IF83FFE01FFEJ01FFE07FF00IFI01FFE00NFC1FFEN0IFK0IF,1KFCO06O03KF8J0QF00IF83FFE01FFEJ01FFE07FF00IFI01FFE01NFC1FFEM01IFK0IF,1KFCY03KF8J0QF007FF83FFC01FFEJ01FFE07FF00IFI01FFE01NFC1FFEN0IFK0IF,1KFCY03KF8J0QF007FFC3FFC01FFEJ01FFE07FF00IFI01FFE03NFC1IFN0IFK0IF,1KFCY03KF8J0QF007FFC7FFC01FFEJ01FFE07FF00IFI01FFE07NFC1IFN0IF8J0IF,1KFCY03KF8J0QF003FFC7FF801IFJ03FFE07FF00IFI01FFE07IF807FFC1IFN0IF8I01IF,1KFCY03KF8J07FFCO03FFE7FF801IFJ03FFE07FF00IFI01FFE0IFE003FFC0IF8I01C00IF8I01IF,1KFCY03KF8J07FFCO03FFEIF800IF8I03FFE07FF00IFI03FFE0IF8003FFC0IF8I03F00IF8I01FFE,1KFCY03KF8J07FFEJ04J01LFI0IF8I07FFC07FF00IFI03FFE0IF8003FFC0IFCI03F807FFCI03FFE,1KFCY03KF8J07FFEJ0F8I01LFI0IFCI0IFC07FF00IF8007FFE0IF8003FFC0IFCI07FE07FFEI07FFE,1KFCY03KF8J03IFI03FEI01LFI07FFE001IFC07FF00IF800IFE0IF8003FFC07FFE001IF07IFI0IFC,1KFCY03KF8J03IF800IFJ0KFEI07IF003IF807FF00IFE03IFE0IF8007FFC07IF803IF83IF801IFC,1KFCY03KF8J01IFE03IF8I0KFEI03IFC0JF807FF00OFE0IFC00IFC03IFC0JF83IFE03IF8,1KFCY03KF8J01OF8I07JFEI03OF007FF00OFE0IFE07IFC03OF01OF8,1KFCY03KF8K0OF8I07JFCI01NFE007FF00OFE0OFC01OF00OF,1KFCY03KF8K07NFJ07JFCJ0NFE007FF00OFE07NFC00NFE00NFE,1KFCY03KF8K07NFJ07JFCJ0NFC007FF007NFE07NFC007MFC007MFE,1KFCY03KF8K03MFEJ03JF8J07MF8007FF007NFE03NFC003MF8003MFC,1KFCY03KF8K01MFCJ03JF8J03MFI07FF003NFE03NFC001MFI01MF8,1KFCY03KF8L07LF8J01JFL0LFEI07FF001NFE01NFCI0LFEJ0LFE,1KFCY03KF8L03KFEK01JFL07KF8I07FFI0KF1FFE00NFCI03KFCJ03KFC,1KFCY03KF8M0KF8K01JFL01JFEJ07FFI03IFE1FFE007JFBFFCI01KFL0KF,1KFCY03KF8M03IFEM0IFEM03IF8J07FFJ0IF81FFC001IFC0FFCJ07IFCL03IFC,1KFCY07KF8N03FEg07F8R01FCN01FEO03IFN03FC,1KFCY07KF8iO01FFE,1KFEY0LF8iO01FFE,1LF8W01LF8iO01FFC,1LFEW07LF8iP0FFC,1MF8U01MF8,1MFCU03MF8,1NFU0NF8,1NFCS03NF8,1NFES0OF8,1OF8Q01OF8,1OFEQ07OF8,1PF8O01PF8,1PFCO07PF8,1QFO0QF8,0QFCM03QFP06K02J07M06N0CS044L01V06O033,07QFM0QFEJ07J01F83C006I01FC0018006M03E7F3F80F078I0CEL018J03FO0400FCK033,03QF8K01QFCJ0FJ01B83C006I039E0038006M0703F1F80F078I0CS03B8Q0CEL03,00QFEK07QFK0F88400187C07E1E0306613CC27E167C0060030300F8F8F07C47C4E1E11E7C031CF177C0E1E00C62CF0E33,003QF8I01QFCJ0199CC0018CC0FE770706633CC67F3CEE007C060300D8F9F8FC66E7F3B39E7C0319B9E6E7F3700EC7DB9B33,I0QFCI03QF8J0198CC0038CC0C66307066338C66338C6007F060700DDB99D8C60E6I39980603B81980E630300FE7019833,I07QFI0QFEK019IC0071DC0C67F07066338C663B0C600630E063CCDBBFD8C63E633FB987E73F0F983E631F3CC660F9E33,I01QFC03QF8K03FC7800E1FE0C66007066338C66330C600630C0E00CF3B818C6EE6330198EE0303998EE6I300C76198733,J07QF0QFEL030E7981E01C0EE60038E7738EE7330C660631C0C00C73981DC6CE6330398CE0303998CE6I300C66398I3,J01gIF8L07067981FC0C07E3F01FC3F1C7E7F30FC603E181C00C739F8FC67E631F198FE0301F987E633F00FC61F9F33,K0gIFY0300C0070100C200400306018P0706002J0EI02K0C003I018L0C0C,K03gGFCgY0C,L0gGF,L07YFE,L01YF8,M07WFE,M01WF8,N0WF,N03UFChQ02,N01UFQ03F807L0F8FC01C7E03C1E078300787C7E3C006X0CX0C,O07SFEQ07F807K01F8FC03C7E07E3F1C0780E0EC7E76006X0CX0C,O01SF8R0E1C7J06180C003C6I0707180F80C0CE066300CR0EI070C00180C1800C1C02300EC04,P07QFES0C3E7018061C0C006C6I0607380D81C0EC0E6300C0C636J3981F319F8CC67E3E7E03E3F3FF80FE7C,P01QF8S0C637J0F1F8F80CC7C03E073F9981FC7C0C7F01C06F367I39831BI9IC60670E70306339DC0E77,Q0QFT0C7F7I03FC3C1C0CC0E01E0E399181CC7C1C3F01806F677I3983F99B0IC61E60C303063B18C0C77,Q03OFCT0C7E7J0601C0E0FE070071C31FFC18CCE180301807FE37E3EF03F1B30IC67E60C303063B18C0C77,R0OFU0C607J0601C0C0FE0700738399FC1CDC63807030039E3DE1EF0300F38ICEI60C723063318C4E77,R07MFEU0C723318061F8FC00C7E07F3F1F8180FCEE302E030039C3CE1CF3398F1F8CFE7E3E6E33E77318CCFE7,R01MF8U043E231I01F0F80047C03C3F0F0100787C207C060010818C0C630F060F08723E1C3C21E3E1188C5C2,S07KFEhU06,S03KF8hU06,T0JFE,T03IFC,U0IF,U07FC,U01F8,,::^FS




^PON
^PW800
^LL400

^FO590,280^A0N,40,30^FD${item.serie}^FS

^FO50,250^A0N,35,35^FDMedidas^FS
^FO50,290^A0N,45,30^FD${item.largo}mtx${item.alto}mt^FS

^FO300,250^A0N,35,35^FDPeso^FS
^FO300,290^A0N,45,30^FD${item.peso} kg^FS

^FO570,50^BQN,2,8^FDQA,${item.serie}^FS
^FO50,170
^A0N,30,25
^FB500,2,5,L,0
^FD${item.producto_descripcion}^FS
^FO50,360^A0N,35,35^FD${item.maquina_descripcion}^FS






^XZ
`;
      } else if (item.id_cliente === 2) {
        // Etiqueta para Sideragro
        zpl = `^XA

^FO30,30^GFA,7102,7102,67,,:::::::lN01FF,lN03838,lN0600C,lN08006,lM018FC2,hX07KFCT01LFhG019FF3,hX07KFCT01LFhG011C338,hX07KFET03KFEhG011E338,hX03LFT07KFEhG011FE38,hX03LFT07KFCgI01IFEM03JFC11FC38,0QFEM03PFCS01LF8K01LF8S07KFCO03IF8O01JFM03JFC11CE3,0RFEL03QF8R03LF8K01LF8S0LFCN03KF8N01JF8L03JFC11C73,0SFCK03RF8Q07LFCL0LFCS0LF8M03MFN01JF8L03JFC19C33,0TFK03RFCQ07LFCL0LFCR01LF8M07MFEM01JFCL03JFC18007,0TFCJ03SF8P07LFCL07KFER01LF8L03OF8L01JFEL03JFC0E00E,0TFEJ03SFCP07LFEL07KFER01LFM0PFCL01JFEL03JFC0603C,0UFJ03SFEP0MFEL03LFR03LFL03QFL01KFL03JFC03FF8,0UF8I03TFP0MFEL03LFR03KFEL07QF8K01KF8K03JFCI04,0UFCI03TF8O0NFL01LF8Q07KFEL0RFEK01KFCK03JFC,0UFEI03TFCN01NFM0LF8Q07KFCK01SFK01KFCK03JFC,0UFEI03TFEN03NF8L0LFCQ07KFCK07SF8J01KFEK03JFC,0UFEI03UFN03NF8L0LFCQ0LFCK0TFEJ01LFK03JFC,0VFI03UFN03NF8L0LFEQ0LF8J01UFJ01LFK03JFC,0VF8003UF8M03NFCL07KFEP01LF8J03UFJ01LF8J03JFC,0VF8003UF8M07NFCL03LFP01LFK03UF8I01LFCJ03JFC,0VF8003UFCM07NFCL03LF8O03LFK07UFCI01LFCJ03JFC,0VF8003UFCM0OFEL03LF8O03KFEK0VFEI01LFEJ03JFC,0VF8003UFEM0OFEL01LF8O07KFEJ01VFEI01MFJ03JFC,0KFCI03LF8003UFEM0OFEM0LFCO07KFEJ03WFI01MF8I03JFC,0KFCJ0LF8003KFI01LFEL01PFM0LFCO07KFCJ03WF8001MFCI03JFC,0KFCJ07KFC003KFJ03KFEL01PFM0LFEO0LFCJ07LFCI07LFC001MFCI03JFC,0KFCJ03KFC003KFJ01KFEL01PF8L07LFO0LF8J07LF8I01LFC001MFEI03JFC,0KFCJ03KFC003KFK0LFL03PF8L03LFN01LF8J0LFCK0LFC001MFEI03JFC,0KFCJ01KF8003KFK0LFL03PF8L03LFN01LF8J0LF8K07KFE001NFI03JFC,0KFCJ01KF8003KFK0LFL03PFCL01LF8M01LFJ01LFL01LF001NF8003JFC,0KFCJ01KF8003KFK07KFL07JFEKFCL01LFCM03LFJ01KFEM0LF001NFC003JFC,0KFCJ01KF8003KFK07KFL07JFEKFCL01LFCM03KFEJ03KFCM0LF801NFC003JFC,0KFCJ03KF8003KFK07KFL0KFC7JFEM0LFCM03KFEJ03KFCM07KF801NFE003JFC,0KFCJ03KF8003KFK07KFL0KFC7JFEM0LFEM07KFEJ03KF8M03KF801OF003JFC,0KFCJ07KFI03KFK07KFL0KFC7JFEM07LFM0LFCJ07KFN03KF801OF003JFC,0KFCJ0KFEI03KFK0KFEL0KFC7KFM07LFM0LFCJ07KFN03KFC01OF803JFC,0KFCI03KFEI03KFK0KFEK01KF83KFM03LF8L0LF8J07KFN01KFC01OFC03JFC,0UFEI03KFK0KFEK01KF83KF8L03LF8K01LF8J07KFN01KFC01OFE03JFC,0UFCI03KFJ01KFEK03KF01KF8L01LF8K01LF8J0KFEN01KFE01PF03JFC,0UF8I03KFJ03KFCK03KF01KF8L01LFCK03LFK0KFEO0KFE01PF03JFC,0UFJ03KFJ0LFCK07KF01KFCM0LFEK03LFK0KFEO0KFE01PF83JFC,0TFEJ03UFCK07KF00KFCM0LFEK03KFEK0KFEO0KFE01PF83JFC,0TF8J03UF8K07JFE00KFCM07LFK07KFEK0KFEO0KFE01PFC3JFC,0SFEK03UF8K0KFE00KFEM07LFK07KFCJ01KFCO0KFE01PFE3JFC,0SF8K03UFL0KFC007JFEM03LF8J0LFCJ01KFCO0KFE01QF3JFC,0SFEK03TFEL0KFC007KFM03LF8J0LF8J01KFCO0KFE01QF3JFC,0TF8J03TFCK01KFC007KFM01LFCI01LF8J01KFCO0KFE01KF7PFC,0TFCJ03TF8K01KFC007KFM01LFCI01LF8J01KFEO0KFE01KF7PFC,0UFJ03TFL01KF8003KF8M0LFEI01LFK01KFEO0KFE01KF3PFC,0UF8I03SFEL03KF8003KF8M0LFEI03LFL0KFEO0KFE01KF1PFC,0UFCI03SFCL03KFI01KFCM0MFI03KFEL0KFEO0KFE01KF0PFC,0UFEI03SF8L07KFI01KFCM07LFI07KFEL0KFEO0KFE01KF07OFC,0VFI03RFEM07KFI01KFCM07LF8007KFEL0LFN01KFE01KF07OFC,0KFCI03LF8003RF8M07KFI01KFCM03LF8007KFCL0LFN01KFE01KF03OFC,0KFCJ07KF8003QFEN07KFJ0KFEM03LFC00LFCL0LFN01KFE01KF01OFC,0KFCJ03KF8003QFEN0KFEJ0KFEM01LFC00LFCL07KFN03KFC01KF01OFC,0KFCJ01KFC003KF1KFEN0UFEM01LFE01LF8L07KF8M03KFC01KF00OFC,0KFCK0KFC003KF1LFM01VFN0LFE01LFM07KFCM07KFC01KF007NFC,0KFCK0KFE003KF0LFM01VFN0MF03LFM07KFCM07KF801KF003NFC,0KFCK0KFE003KF07KF8L01VFN07LF83LFM03KFEM0LF801KF003NFC,0KFCK07JFE003KF07KF8L03VF8M07LF83KFEM03LFL01LF801KF001NFC,0KFCK07KF003KF03KFCL03VF8M03LFC7KFEM03LF8K03LF801KFI0NFC,0KFCK07KF003KF03KFEL03VFCM03LFCLFCM01LFCK07LF001KFI0NFC,0KFCK0LF003KF01KFEL07VFCM01LFELFCM01LFEK0MF001KFI07MFC,0KFCJ01LF003KF01LFL07VFCM01LFELFCM01MF8I07LFE001KFI03MFC,0KFCJ01LF003KF00LFL0WFEM01SF8N0NF001MFC001KFI01MFC,0KFCJ03LF003KF00LF8K0WFEN0SF8N07WFC001KFI01MFC,0KFEJ0MF003KF007KFCK0WFEN07RF8N07WFC001KFJ0MFC,0WF003KF003KFCJ01XFN07RFO03WF8001KFJ07LFC,0VFE003KF003KFEJ01XFN07QFEO03WFI01KFJ07LFC,0VFE003KF001KFEJ03XF8M03QFEO01VFEI01KFJ03LFC,0VFC003KF001LFJ03XF8M01QFEP0VFEI01KFJ01LFC,0VFC003KF001LFJ03XF8M01QFCP07UFCI01KFJ01LFC,0VFC003KFI0LF8I03KF8L03KF8M01QFCP07UF8I01KFK0LFC,0VF8003KFI07KFCI07KF8L03KFCN0QF8P03UF8I01KFK07KFC,0VF8003KFI07KFCI0LFM01KFEN07PF8P01UFJ01KFK03KFC,0VFI03KFI07KFEI0LFM01KFEN07PF8Q0TFEJ01KFK01KFC,0UFEI03KFI03KFEI0KFEN0KFEN07PFR07SF8J01KFK01KFC,0UFEI03KFI01LFI0KFEN0KFEN03PFR03SFK01KFK01KFC,0UFCI03KFI01LF001KFEN0LFN03OFES0RFEK01KFL0KFC,0UF8I03KFJ0LF801KFCN07KFN01OFES07QF8K01KFL07JFC,0TFEJ03KFJ0LFC01KFCN07KF8M01OFCS03QFL01KFL03JFC,0TF8J03KFJ07KFC03KFCN07KF8N0OFCT0PFEL01KFL01JFC,0TFK03KFJ03KFE03KFCN03KF8N0OFCT03OF8L01KFM0JFC,0SFL03KFJ03KFE07KF8N03KFCN07NF8U0NFEM01KFM0JFC,0RF8L07KFJ01LF07KF8N03KFCN07NF8U03MFN01KFM07IFC,iN03NFW07KFCN01KFM07IFC,iN03NFX03IF8O01KFM03IFC,iN01NF,iN01MFE,iO0MFE,iO0MFC,:^FS





^PON
^PW800
^LL400

^FO590,280^A0N,40,30^FD${item.serie}^FS

^FO50,250^A0N,35,35^FDMedidas^FS
^FO50,290^A0N,45,30^FD${item.largo}mtx${item.alto}mt^FS


^FO570,50^BQN,2,8^FDQA,${item.serie}^FS
^FO50,170
^A0N,30,25
^FB500,2,5,L,0
^FD${item.producto_descripcion}^FS
^FO50,360^A0N,35,35^FD${item.maquina_descripcion}^FS



^XZ
`;
      } else if (item.id_cliente === 3) {
        // Etiqueta para Interno
        zpl = `^XA

^FO95,1^GFA,7776,7776,48,,::hM06,hM0F,hL01F,hL01F8,hL03F8,hL03FC,hL07FC,hL0FFE,:hK01IF,hK01FBF,hK01F9F8,hK03F0F8,:hK07E0FC,hK07E07C,hK0FC07E,hK0FC03E,:hJ01F801F,:hJ01FI0F,hJ03FI0F8,:hJ03EI078,hJ07EI07C,:hJ07CI03C,hJ0FCI03C,:hJ0FCI01E,hJ0F8I01E,:hI01F8J0E,::hI01FK0E,hI01FK0F,hI01FK07,:hI03FK07,::hI03EK07O0FF,gQ07JFM03EK07M07JFC,gQ07KFL03EK07L07KFE,gQ07KFEK03EK07K03LFC,gQ07LFCJ03EK03J01MFC,gQ07MFJ03EK03J07MFC,gQ03FI0IFCI03EK03I01KFE1F8,gQ03FJ03FFI03EK03I07IF8001F8,gQ03FK03FC003EK03001IFJ01F8,gQ01F8K07E001EK02003FF8J01F,gQ01F8L0F801EK02007FCK03F,gR0FCL03C01FK0201FFL03E,gR0FCM0E01FM03FCL07E,gR07EM0701FM07FM07C,gR07EM0181FM0FCM0FC,gR03FN0C0FL01F8M0FC,gR03FP0FL03FM01F8,gR01F8O0FL07EM01F,gR01F8O0FL0F8M03F,gS0FCO078K0FN07E,gS0FEO078J01EN07E,gS07EO078J03CN0FC,gS07FO078J078N0FC,gS03F8N038J07N01F8,gS01F8N03CJ0EN03F,gS01FCN03CI01EN07F,gT0FEN01CI01CN07E,gT07FN01CI038N0FC,gT03F8M01EI03N01F8,gT03F8N0EI07N03F8,gT01FCN0EI06N07F,gU0FEN0FI0CN0FE,gU07FN07I0CM01FC,gU03F8M070018M03F8,gU01FCM03801N07F,gV0FEM03803N0FE,gV07F8L01802M01FC,gV03FCL01C06M03F8,gV01FFM0C04M0FF,gW0FF8L0EN01FC,gW07FEL06N07F8,gW01FF8K06M01FE,gX0FFEK03M07F8,gX03FFCJ01L01FE,gY0IF8P0FF8,gY01IFCN0FFC,h03JFK03FFE,hG07JFC03IFE,hH03IF8,,::::::::::::::::::::::::::::::I07FCiV0FF8,001IF8gM01JFChG03IFL0C,007IFEgM01KFhG0JF8K0C,00F800EgH07FE001KFCV07FCg01E001CJ01E,03EL0JF818I0183IFC001IF801KFE01JF8I03J01IF03JFC3J0FI018003CN01E,078K01JFC18I0183JF007C03E01F807FF01JFCI07J07IF83JFC38I0FI0380038N03F,07L01CI0E18I0183I0780FI0F01FI01F81JFEI078I0JFC3JFC3CI0FI03C003O033,0EL01CI0618I0183I0381CI0381FJ0FC1KFI0F8001FF1FC3JFC3EI0FI07C007O0618,1CL01CI0618I0183I01C38I01C1FJ07C1F003FI0FC003F801E3EJ03FI0FI0FE0038N0618,1CL01CI0718I0183I01C3K0C1FJ03E1EI0F001FC007EI043EJ03F800FI0FE0038N0C0C,38L01CI0718I0183I01C7K0E1FJ03E1EI0F803FE007CJ03EJ03FE00F001FF003CN0C0E,38L01CI0618I0183I01C6K071FJ03E1EI0F803FF00FCJ03EJ03FF00F001FF001F8L01806,38L01CI0618I0183I01CEK071FJ01E1EI0F807DF00F8J03EJ03FF80F003EF8007FCK01807,38L01CI0E18I0183I038CK031FJ01E1EI0F8078F80F8J03FJ03CFC0F007C7C001FFCJ03003,38I07FF1E001C18I0183I0F8CK031FJ01E1F003F00F8F80FK03JF03C7E0F007C7CI03FFJ070038,38I03FF1JF818I0183JF0CK031FJ01E1KF00F07C0FK03JF03C3F0F00F83EJ03FCI060018,38K071JF01CI0383IFC0CK031FJ03E1JFE01F07C0F8J03JF03C1F8F00F83EK03EI0E001C,38K071E00E01CI0383K0EK031FJ03E1JFC01E03E0F8J03IFE03C0FCF01F01FL0EI0JFC,1CK071C00701CI0383K0EK071FJ03E1JFC03E03F0F8J03EJ03C07FF01F01FL07001JFE,1CK061C00701CI0383K0EK071FJ07E1JF807JF0FCJ03EJ03C03FF03JF8K07001CI0E,0EK0E1C00380CI0383K07K061FJ07C1E007C07JF87CJ03EJ03C01FF03JF8K070038I07,0EK0E1C00180EI0703K07K0E1FJ0FC1E007C0KF87EJ03EJ03C00FF07JFCK070038I038,07J01C1C001C0EI0703K038I01C1FI07F81E003E0KFC3FI0E3EJ03C003F07JFCK07007J038,038I0381CI0C07I0E03K01CI0381LF01E003E1FE007C1FC07E3JF83C001F0FE003EK0F006J01C,01EI0701CI0E03801E03L0EI0701KFE01E001F1FI03E0JFC3JFC3CI0F0F8003E7I01E10EJ01C,00F803E00CI0603E07C03L07803E01KF801E001F3EI03E07IFC3JFC3CI071FI01F7F007C18CK0E,003IFC00CI0700IF003L03IF801JFE001EI0FFCI01F03IF03JFC3CI031EJ0F1JF819CK0E,I0FFEM03003FC002M07FEI07FP03O07FC01IF0018P0603FFCO02,,:::::::^FS

^PON
^PW800
^LL400

^FO595,280^A0N,40,30^FD${item.serie}^FS

^FO50,250^A0N,35,35^FDMedidas^FS
^FO50,290^A0N,45,30^FD${item.largo}mtx${item.alto}mt^FS

^FO300,250^A0N,35,35^FDPeso^FS
^FO300,290^A0N,45,30^FD${item.peso} kg^FS

^FO570,50^BQN,2,8^FDQA,${item.serie}^FS
^FO50,170
^A0N,30,25
^FB500,2,5,L,0
^FD${item.producto_descripcion}^FS
^FO50,360^A0N,35,35^FD${item.maquina_descripcion}^FS




^XZ
`;
      } else {
        console.error("Cliente no soportado para impresión.");
        return;
      }

      if (window.BrowserPrint) {
        window.BrowserPrint.getDefaultDevice("printer", (device) => {
          if (device) {
            device.send(
              zpl,
              () => {
                console.log("Etiqueta enviada a la impresora.");
              },
              (err) => {
                console.error("Error al imprimir:", err);
              },
            );
          }
        });
      } else {
        console.error("BrowserPrint no está disponible.");
      }
    } catch (error) {
      console.error("Error al imprimir la etiqueta:", error);
    }
  };

  const handleFormSubmit = async (values, { resetForm }) => {
    setIsLoading(true);
    const USER = secureStorage.getItem("id");

    const {
      id_producto,
      alto,
      largo,
      cantidad,
      obs,
      id_maquina,
      peso,
      id_cliente,
    } = values;

    const valuesToSend = {
      id_producto,
      alto: parseFloat(alto),
      largo: parseFloat(largo),
      cantidad: parseInt(cantidad),
      peso: parseFloat(peso),
      id_maquina,
      id_usuario: parseInt(USER),
      id_cliente,
    };
    if (parseFloat(largo) !== 25) {
      valuesToSend.obs = obs;
    }
    if (values.tipo_registro === "doble") {
      valuesToSend.puntototal = parseFloat(values.puntototal);

      valuesToSend.usuarios = [
        {
          id_maquina: parseInt(values.id_maquina),
          puntoproducido: parseFloat(values.puntoproducido1),
        },
        {
          id_maquina: parseInt(values.id_maquina_2),
          puntoproducido: parseFloat(values.puntoproducido2),
        },
      ];
    }
    try {
      await new Promise((resolve) => setTimeout(resolve, 2000));
      const cantidad = parseInt(values.cantidad);
      for (let i = 0; i < cantidad; i++) {
        const response = await postStockTejidos({
          ...valuesToSend,
          cantidad: 1,
        });

        await imprimirEtiqueta({
          ...response.data,
          producto_descripcion: productoSeleccionado?.descripcion,
          maquina_descripcion: maquinaSeleccionada?.descripcion,
        });
      }
      toast.success("Registrado exitosamente", {
        position: "top-center", // o "bottom-center"
      });

      // resetForm();
      // setProductoSeleccionado(null);
      // setMaquinaSeleccionada(null);
      // setMaquina2Seleccionada(null);
    } catch (error) {
      console.error("Error al enviar datos", error);
      setRegistrationError(true);
      setIsLoading(false);
      setError(error.message);
      toast.error("Ocurrió un error al registrar", {
        position: "top-center", // o "bottom-center"
      });
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 3000);
    }
  };

  const handleCloseModal = () => setRegistrationSuccess(false);
  const handleCloseModalError = () => setRegistrationError(false);

  return (
    <Box m="20px">
      <Header title="Registro en Stock" subtitle="Registro Stock/Tejidos" />
      {isLoading && <LoadingSpinner />}
      <ModalCharge open={isModalChargeOpen} />
      <ModalSucces open={registrationSuccess} onClose={handleCloseModal} />
      <ModalError
        open={registrationError}
        onClose={handleCloseModalError}
        error={error}
      />

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={{
          id_producto: "",
          alto: "",
          largo: "",
          cantidad: "",
          obs: "",
          peso: "",
          id_maquina: "",
          id_cliente: "",
          tipo_registro: "individual",
          puntototal: "",
          puntoproducido1: "",
          id_maquina_2: "",
          puntoproducido2: "",
          descripcion_maquina_2: "",
        }}
        validationSchema={checkoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
        }) => {
          setFieldValueRef.current = setFieldValue;

          return (
            <form onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <TextField
                  select
                  fullWidth
                  variant="filled"
                  label="Tipo Registro"
                  name="tipo_registro"
                  value={values.tipo_registro}
                  onChange={handleChange}
                  sx={{ gridColumn: "span 2" }}
                >
                  <MenuItem value="individual">Individual</MenuItem>

                  <MenuItem value="doble">Dos Operadores</MenuItem>
                </TextField>
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Producto"
                  name="id_producto"
                  value={values.cod || ""}
                  onClick={() => setIsModalTejidoOpen(true)}
                  InputProps={{ readOnly: true }}
                  error={!!touched.id_producto && !!errors.id_producto}
                  helperText={touched.id_producto && errors.id_producto}
                  sx={{ gridColumn: "span 2", cursor: "pointer" }}
                />

                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Alto"
                  name="alto"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.alto || ""}
                  error={!!touched.alto && !!errors.alto}
                  helperText={touched.alto && errors.alto}
                  sx={{ gridColumn: "span 2" }}
                />

                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Largo"
                  name="largo"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.largo || ""}
                  error={!!touched.largo && !!errors.largo}
                  helperText={touched.largo && errors.largo}
                  sx={{ gridColumn: "span 2" }}
                />

                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Cantidad"
                  name="cantidad"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.cantidad || ""}
                  error={!!touched.cantidad && !!errors.cantidad}
                  helperText={touched.cantidad && errors.cantidad}
                  sx={{ gridColumn: "span 2" }}
                />

                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Peso"
                  name="peso"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.peso || ""}
                  error={!!touched.peso && !!errors.peso}
                  helperText={touched.peso && errors.peso}
                  sx={{ gridColumn: "span 2" }}
                />

                <TextField
                  select
                  fullWidth
                  variant="filled"
                  label="Cliente"
                  name="id_cliente"
                  value={values.id_cliente || ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={!!touched.id_cliente && !!errors.id_cliente}
                  helperText={touched.id_cliente && errors.id_cliente}
                  sx={{ gridColumn: "span 2" }}
                >
                  <MenuItem value={1}>Evoluaço</MenuItem>
                  <MenuItem value={2}>Sideragro</MenuItem>
                  <MenuItem value={3}>Interno</MenuItem>
                </TextField>
                {parseFloat(values.largo) !== 25 && (
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Observación"
                    name="obs"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.obs || ""}
                    error={!!touched.obs && !!errors.obs}
                    helperText={touched.obs && errors.obs}
                    sx={{ gridColumn: "span 2" }}
                  />
                )}
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Máquina 1"
                  name="id_maquina"
                  onClick={() => setIsModalMaquinaOpen(true)}
                  InputProps={{ readOnly: true }}
                  value={values.descripcion || ""}
                  error={!!touched.id_maquina && !!errors.id_maquina}
                  helperText={touched.id_maquina && errors.id_maquina}
                  sx={{ gridColumn: "span 2", cursor: "pointer" }}
                />
                {values.tipo_registro === "doble" && (
                  <>
                    <TextField
                      fullWidth
                      variant="filled"
                      type="text"
                      label="Máquina 2"
                      name="id_maquina_2"
                      onClick={() => setIsModalMaquina2Open(true)}
                      InputProps={{ readOnly: true }}
                      value={values.descripcion_maquina_2 || ""}
                      error={!!touched.id_maquina_2 && !!errors.id_maquina_2}
                      helperText={touched.id_maquina_2 && errors.id_maquina_2}
                      sx={{
                        gridColumn: "span 2",
                        cursor: "pointer",
                      }}
                    />
                    <TextField
                      fullWidth
                      variant="filled"
                      type="number"
                      label="Puntos Totales"
                      name="puntototal"
                      onBlur={handleBlur}
                      onChange={(e) => {
                        const total = parseFloat(e.target.value) || 0;

                        setFieldValue("puntototal", total);

                        const producido1 =
                          parseFloat(values.puntoproducido1) || 0;

                        if (producido1 > total) {
                          setFieldValue("puntoproducido1", "");
                          setFieldValue("puntoproducido2", "");
                          return;
                        }

                        if (producido1 > 0) {
                          setFieldValue("puntoproducido2", total - producido1);
                        }
                      }}
                      value={values.puntototal}
                      error={!!touched.puntototal && !!errors.puntototal}
                      helperText={touched.puntototal && errors.puntototal}
                      sx={{ gridColumn: "span 2" }}
                    />

                    <TextField
                      fullWidth
                      variant="filled"
                      type="number"
                      label="Puntos Máquina 1"
                      name="puntoproducido1"
                      onBlur={handleBlur}
                      onChange={(e) => {
                        const producido1 = parseFloat(e.target.value) || 0;

                        const total = parseFloat(values.puntototal) || 0;

                        if (producido1 > total) {
                          return;
                        }

                        setFieldValue("puntoproducido1", producido1);

                        setFieldValue("puntoproducido2", total - producido1);
                      }}
                      value={values.puntoproducido1}
                      error={
                        !!touched.puntoproducido1 && !!errors.puntoproducido1
                      }
                      helperText={
                        touched.puntoproducido1 && errors.puntoproducido1
                      }
                      sx={{ gridColumn: "span 2" }}
                    />

                    <TextField
                      fullWidth
                      variant="filled"
                      type="number"
                      label="Puntos Máquina 2"
                      name="puntoproducido2"
                      value={values.puntoproducido2 || ""}
                      InputProps={{
                        readOnly: true,
                      }}
                      sx={{ gridColumn: "span 2" }}
                    />
                  </>
                )}
              </Box>

              <Box display="flex" justifyContent="end" mt="20px">
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    backgroundColor: "rgb(206, 220, 0)",
                    color: "black",
                    height: "7vh",
                    width: "10vw",
                    borderRadius: "20px",
                    "&:hover": { backgroundColor: "#bac609" },
                  }}
                >
                  Registrar Tejido
                </Button>
              </Box>

              <ModalProductosTejido
                open={isModalTejidoOpen}
                onClose={() => setIsModalTejidoOpen(false)}
                onSelectProduct={(producto) => {
                  setProductoSeleccionado(producto);
                  setFieldValue("id_producto", producto.id); // Para enviar al backend
                  setFieldValue("cod", producto.cod);
                }}
              />
              <ModalMaquinasTejido
                open={isModalMaquinaOpen}
                onClose={() => setIsModalMaquinaOpen(false)}
                onSelectMaquina={(maquina) => {
                  setFieldValue("id_maquina", maquina.id);
                  setFieldValue("descripcion", maquina.descripcion);
                  setMaquinaSeleccionada(maquina);
                }}
              />
              <ModalMaquinasTejido
                open={isModalMaquina2Open}
                onClose={() => setIsModalMaquina2Open(false)}
                onSelectMaquina={(maquina) => {
                  setFieldValue("id_maquina_2", maquina.id);
                  setFieldValue("descripcion_maquina_2", maquina.descripcion);

                  setMaquina2Seleccionada(maquina);

                  setIsModalMaquina2Open(false);
                }}
              />
              <ModalCharge isLoading={isLoading} />
            </form>
          );
        }}
      </Formik>
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  id_producto: yup.number().required("El producto es requerido"),
  alto: yup
    .number()
    .typeError("Alto debe ser un número")
    .required("Alto es requerido")
    .positive("Alto debe ser positivo"),
  largo: yup
    .number()
    .typeError("Largo debe ser un número")
    .required("Largo es requerido")
    .positive("Largo debe ser positivo"),
  cantidad: yup
    .number()
    .typeError("Cantidad debe ser un número")
    .required("Cantidad es requerido")
    .positive("Cantidad debe ser positivo"),
  obs: yup.string().when("largo", {
    is: (largo) => parseFloat(largo) !== 25,
    then: (schema) => schema.required("Observación es requerida"),
    otherwise: (schema) => schema.notRequired(),
  }),
  id_maquina: yup.string().required("Es requerido la máquina"),
  peso: yup
    .number()
    .typeError("Peso debe ser un número")
    .required("Peso es requerido")
    .positive("Peso debe ser positivo"),
  id_cliente: yup
    .number()
    .required("El cliente es requerido")
    .oneOf([1, 2, 3], "Cliente inválido"),
  tipo_registro: yup.string().required(),

  puntototal: yup.number().when("tipo_registro", {
    is: "doble",
    then: (schema) => schema.required("Punto total requerido").positive(),
    otherwise: (schema) => schema.notRequired(),
  }),

  puntoproducido1: yup.number().when("tipo_registro", {
    is: "doble",
    then: (schema) =>
      schema
        .required("Punto producido requerido")
        .positive()
        .test(
          "max-total",
          "No puede ser mayor al punto total",
          function (value) {
            return value <= this.parent.puntototal;
          },
        ),
    otherwise: (schema) => schema.notRequired(),
  }),

  id_maquina_2: yup.string().when("tipo_registro", {
    is: "doble",
    then: (schema) => schema.required("Máquina 2 requerida"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export default StockTejido;
